import React from 'react';
import { X, Phone } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
interface ServiceModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: string;
  icon: React.ReactNode;
}
export function ServiceModal({
  isOpen,
  onClose,
  title,
  content,
  icon
}: ServiceModalProps) {
  const {
    t
  } = useLanguage();
  return <AnimatePresence data-id="element-190">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-brand-black/60 backdrop-blur-sm z-50" data-id="element-191" />

          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none" data-id="element-192">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2
        }} className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col pointer-events-auto" data-id="element-193">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-gray-100 bg-gray-50 rounded-t-xl" data-id="element-194">
                <div className="flex items-center gap-4" data-id="element-195">
                  <div className="p-2.5 bg-brand-blue rounded-lg text-white" data-id="element-196">
                    {icon}
                  </div>
                  <h2 className="text-2xl font-heading font-bold text-brand-black" data-id="element-197">
                    {title}
                  </h2>
                </div>
                <button onClick={onClose} className="p-2 text-gray-400 hover:text-brand-red hover:bg-red-50 rounded-full transition-colors" data-id="element-198">
                  <X className="w-6 h-6" data-id="element-199" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 overflow-y-auto flex-1" data-id="element-200">
                <div className="space-y-3" data-id="element-201">
                  {content.split('\n').map((line, index) => {
                const trimmed = line.trim();
                if (!trimmed) return <div key={index} className="h-3" data-id="element-202" />;
                if (trimmed === trimmed.toUpperCase() && trimmed.length > 3 && !trimmed.startsWith('•') && !trimmed.match(/^\d/)) {
                  return <h3 key={index} className="text-lg font-heading font-bold text-brand-blue mt-4 mb-2 border-b border-gray-100 pb-2" data-id="element-203">
                          {trimmed}
                        </h3>;
                }
                if (trimmed.startsWith('•')) {
                  return <div key={index} className="flex items-start gap-2 pl-2" data-id="element-204">
                          <span className="text-brand-red font-bold mt-0.5" data-id="element-205">
                            •
                          </span>
                          <p className="text-gray-700 leading-relaxed" data-id="element-206">
                            {trimmed.slice(1).trim()}
                          </p>
                        </div>;
                }
                if (trimmed.match(/^\d+\./)) {
                  return <div key={index} className="flex items-start gap-3 pl-2" data-id="element-207">
                          <span className="text-brand-blue font-bold text-sm mt-0.5 flex-shrink-0" data-id="element-208">
                            {trimmed.split('.')[0]}.
                          </span>
                          <p className="text-gray-700 leading-relaxed" data-id="element-209">
                            {trimmed.split('.').slice(1).join('.').trim()}
                          </p>
                        </div>;
                }
                return <p key={index} className="text-gray-700 leading-relaxed" data-id="element-210">
                        {trimmed}
                      </p>;
              })}
                </div>
              </div>

              {/* Footer CTA */}
              <div className="p-6 border-t border-gray-100 bg-gray-50 rounded-b-xl flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-211">
                <a href="tel:8324397965" className="w-full sm:w-auto flex items-center justify-center gap-2 bg-brand-red text-white px-6 py-3 rounded-md font-bold hover:bg-red-800 transition-colors shadow-md min-h-[48px]" data-id="element-212">
                  <Phone className="w-5 h-5" data-id="element-213" />
                  {t.services.callNow}
                </a>
                <button onClick={onClose} className="text-gray-500 hover:text-gray-700 font-medium transition-colors" data-id="element-214">
                  Close
                </button>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}